import { ODataSelect } from "../../../../Providers.Api/ODataQuery"

export class Space extends ODataSelect
{
    Node_Id = 0;
    Space_Id = '';
    Space_Type = '';
    Space_Name = '';
}

export interface ISpaceData
{
    Node_Id: number;
    Space_Id: string;
    Space_Type: string;
}


export interface ITaskCategoryData
{
    Task_Category_Id: string;
    Task_Category_Name: string;
    Space_Type: string;
}

export class TaskCategoryData extends ODataSelect
{
    Task_Category_Id = '';
    Task_Category_Name = '';
    Space_Type = '';
}
export class TaskTypeData extends ODataSelect
{
    public Task_Type_Id = '';
    public Task_Type_Name = '';
}

export interface ITask
{
    Task_Priority: number;
    Task_Category_Name: string;
    Task_Type_Name: string;
    Task_Description: string;
    Task_CreatedBy: string;
    Node_Id: number;
    Task_Owner: string;
    Space_Id: string;
    Task_Status: string;
    Task_Type_Id: number;
    Booking_Id: string;
}

export class Task extends ODataSelect
{

    Task_Priority = 0;
    Task_Category_Name = '';
    Task_Type_Name = '';
    Task_Description = '';
    Task_CreatedBy = '';
    Node_Id = 0;
    Task_Owner = '';
    Space_Id = '';
    Task_Status = '';
    Task_Type_Id = '';
    Booking_Id = '';
}

export interface ICreateTask
{
    Space_Id: string;
    Task_Category_Id: number;
    Task_Type_Id: number;
    Task_Description: string;
    DisableExtUpdate: boolean;

}

export interface IUpdateTask
{
    Task_Description: string;
}
